export const KYCLang = {
    step1_1: {
        'en': 'To enable $ARTY withdrawal, please complete the Identity Verification (KYC).',
        'fr': 'Pour pouvoir effectuer un retrait de $ARTY, veuillez terminer la vérification d`identité (KYC).',
        'de': 'Um die Abhebung von $ARTY zu ermöglichen, durchlaufen Sie bitte eine Identitätsbestätigung (KYC).',
        'ko': '$ARTY 출금을 활성화하려면 신원 확인(KYC)을 완료하세요.',
        'ch': '要启用$ARTY提款，请先完成身份验证 (KYC)。',
        'ru': 'Чтобы вывести $ARTY, пройдите проверку личности (KYC).',
        'it': 'Per abilitare il ritiro di $ARTY si prega di completare la Verifica dell`Identità (KYC).',
        'jap': '$ARTYの出金を有効にするには、本人確認（KYC）を完了してください。',
        'port': 'Para habilitar o saque de $ARTY, complete a Verificação de Identidade (KYC).',
        'turk': '$ARTY çekme işlemini etkinleştirmek için lütfen Kimlik Doğrulama (KYC) işlemini tamamlayın.',
        'viet': 'Để bật tính năng rút ARTY$, hãy hoàn thành quá trình Xác minh danh tính (KYC).',
        'spa': 'Para permitir la retirada de $ARTY, completa la verificación de identidad (KYC).',
        'arab': 'لتمكين سحب $ARTY، يرجى إكمال التحقق من الهوية (KYC).'
    },
    step1_2: {
        'en': 'Withdrawal will be available after the Token Generation Event (TGE).',
        'fr': 'Le retrait ne sera possible qu`après le Token Generation Event (TGE).',
        'de': 'Eine Abhebung wird nach dem Token Generation Event (TGE) verfügbar sein.',
        'ko': '출금은 토큰 생성 이벤트(TGE) 이후 가능합니다.',
        'ch': '代币产生活动 (TGE) 之后可进行提款。',
        'ru': 'Вывод будет доступен после события генерации токенов (TGE).',
        'it': 'Il ritiro sarà disponibile dopo l`Evento di Generazione Token (EGT).',
        'jap': 'トークン生成イベント（TGE）後に出金できるようになります。',
        'port': 'O saque estará disponível após o evento de geração de token (TGE)',
        'turk': 'Çekme işlemi Token Üretim Etkinliğinden (TGE) sonra kullanılabilecektir.',
        'viet': 'Bạn có thể rút sau Sự kiện tạo token (TGE).',
        'spa': 'La retirada estará disponible después del Evento de Generación de Fichas (TGE)',
        'arab': 'سيكون السحب متاحًا بعد حدث إنشاء العملة (TGE Token Generation).'
    },
    step1_3: {
        'en': 'Required',
        'fr': 'Obligatoire',
        'de': 'Erforderlich',
        'ko': '필요 사항',
        'ch': '所需',
        'ru': 'Обязательный',
        'it': 'Obbligatorio',
        'jap': '必須事項です',
        'port': 'Necessário',
        'turk': 'Gerekli',
        'viet': 'Bắt buộc',
        'spa': 'Requerido',
        'arab': 'مطلوب'
    },
    step1_4: {
        'en': 'Personal information',
        'fr': 'Informations personnelles',
        'de': 'Personenbezogene Informationen',
        'ko': '개인 정보',
        'ch': '个人信息',
        'ru': 'Личная информация',
        'it': 'Informazioni personali',
        'jap': '個人情報',
        'port': 'Informações pessoais',
        'turk': 'Kişisel bilgiler',
        'viet': 'Thông tin cá nhân',
        'spa': 'Información personal',
        'arab': 'معلومات شخصية'
    },
    step1_5: {
        'en': 'Photo of the identity document',
        'fr': 'Photo du document d`identité',
        'de': 'Foto des Personalausweises',
        'ko': '신분증 사진',
        'ch': '身份证照片',
        'ru': 'Фото идентификационного документа',
        'it': 'Foto del documento d`identità',
        'jap': '身分証明書の写真',
        'port': 'Foto do documento de identidade',
        'turk': 'Kimlik belgesinin resmi',
        'viet': 'Ảnh tài liệu danh tính',
        'spa': 'Foto del documento de identidad',
        'arab': 'صورة من وثيقة الهوية'
    },
    step1_6: {
        'en': 'Selfie',
        'fr': 'Selfie',
        'de': 'Selfie',
        'ko': '본인의 사진',
        'ch': '自拍',
        'ru': 'Селфи',
        'it': 'Selfie',
        'jap': '自撮り写真',
        'port': 'Selfie',
        'turk': 'Özçekim',
        'viet': 'Ảnh selfie',
        'spa': 'Selfie',
        'arab': 'سيلفي'
    },
    step1_7: {
        'en': 'Estimated time: 3 min.',
        'fr': 'Temps estimé : 3 min.',
        'de': 'Verbleibende Zeit: 3 min.',
        'ko': '예상 시간: 3분.',
        'ch': '预计时间：3 分钟。',
        'ru': 'Расчетное время: 3 мин.',
        'it': 'Tempo stimato: 3 minuti.',
        'jap': '所要時間：3分。',
        'port': 'Tempo estimado: 3 min.',
        'turk': 'Tahmini süre 3 dk.',
        'viet': 'Thời gian ước tính: 3 phút.',
        'spa': 'Tiempo estimado: 3 min',
        'arab': 'الوقت المقدر: 3 دقائق.'
    },
    step1_8: {
        'en': 'Start Now',
        'fr': 'Commence dès maintenant',
        'de': 'Jetzt beginnen',
        'ko': '지금 시작하기',
        'ch': '现在开始',
        'ru': 'Начать сейчас',
        'it': 'Inizia Ora',
        'jap': '今すぐ始める',
        'port': 'Comece agora',
        'turk': 'Hemen Başla',
        'viet': 'Bắt đầu ngay',
        'spa': 'Empezar ahora',
        'arab': 'ابدأ الآن'
    },
    step2_1: {
        'en': 'Nationality',
        'fr': 'Nationalité',
        'de': 'Staatsangehörigkeit',
        'ko': '국적',
        'ch': '国籍',
        'ru': 'Национальность',
        'it': 'Nazionalità',
        'jap': '国籍',
        'port': 'Nacionalidade',
        'turk': 'Uyruk',
        'viet': 'Quốc tịch',
        'spa': 'Nacionalidad',
        'arab': 'الجنسية'
    },
    step2_2: {
        'en': 'First Name',
        'fr': 'Prénom',
        'de': 'Vorname',
        'ko': '이름',
        'ch': '名',
        'ru': 'Имя',
        'it': 'Nome',
        'jap': '名',
        'port': 'Primeiro nome',
        'turk': 'İsim',
        'viet': 'Tên',
        'spa': 'Nombre',
        'arab': 'الاسم '
    },
    step2_3: {
        'en': 'Last Name',
        'fr': 'Nom de famille',
        'de': 'Nachname',
        'ko': '성',
        'ch': '姓',
        'ru': 'Фамилия',
        'it': 'Cognome',
        'jap': '姓',
        'port': 'Sobrenome',
        'turk': 'Soyisim',
        'viet': 'Họ',
        'spa': 'Apellidos',
        'arab': 'اللقب'
    },
    step2_4: {
        'en': 'Date of Birth',
        'fr': 'Date de naîssance',
        'de': 'Geburtsdatum',
        'ko': '생년월일',
        'ch': '出生日期',
        'ru': 'Дата рождения',
        'it': 'Data di Nascita',
        'jap': '生年月日',
        'port': 'Data de nascimento',
        'turk': 'Doğum Tarihi',
        'viet': 'Ngày sinh',
        'spa': 'Fecha de nacimiento',
        'arab': 'تاريخ الولادة'
    },
    step2_5: {
        'en': 'Residential Address',
        'fr': 'Adresse',
        'de': 'Meldeadresse',
        'ko': '주거지 주소',
        'ch': '住宅地址',
        'ru': 'Адрес проживания',
        'it': 'Indirizzo di residenza',
        'jap': '住所',
        'port': 'Endereço residencial',
        'turk': 'İkamet Adresi',
        'viet': 'Địa chỉ cư trú',
        'spa': 'Dirección particular',
        'arab': 'عنوان السكن'
    },
    step2_6: {
        'en': 'Country',
        'fr': 'Pays',
        'de': 'Land',
        'ko': '국가',
        'ch': '国家',
        'ru': 'Страна',
        'it': 'Paese',
        'jap': '国名',
        'port': 'País',
        'turk': 'Ülke',
        'viet': 'Quốc gia',
        'spa': 'País',
        'arab': 'الدولة'
    },
    step2_7: {
        'en': 'Postal Code',
        'fr': 'Code postal',
        'de': 'Postleitzahl',
        'ko': '우편번호(ZIP CODE)',
        'ch': '邮政编码',
        'ru': 'Почтовый индекс',
        'it': 'Codice Postale',
        'jap': '郵便番号',
        'port': 'CEP',
        'turk': 'Posta Kodu',
        'viet': 'Mã bưu điện',
        'spa': 'Código postal',
        'arab': 'الصندوق البريدي'
    },
    step2_8: {
        'en': 'City',
        'fr': 'Ville',
        'de': 'Ort',
        'ko': '도시',
        'ch': '城市',
        'ru': 'Город',
        'it': 'Città',
        'jap': '市区町村',
        'port': 'Cidade',
        'turk': 'Şehir',
        'viet': 'Thành phố',
        'spa': 'Ciudad',
        'arab': 'المدينة'
    },
    step2_continue: {
        'en': 'Continue',
        'fr': 'Continuer',
        'de': 'Fortfahren',
        'ko': '계속하기',
        'ch': '继续',
        'ru': 'Продолжить',
        'it': 'Continua',
        'jap': '進む',
        'port': 'Continuar',
        'turk': 'Devam Et',
        'viet': 'Tiếp tục',
        'spa': 'Continuar',
        'arab': 'واصل'
    },
    verify_info: {
        'en': 'This information is used for personal verification only, and is kept private and confidential by Artyfact.',
        'fr': 'Ces informations ne sont utilisées qu`à des fins de vérification d`identité, et sont conservées de manière privée et confidentielle par Artyfact.',
        'de': 'Diese Informationen werden nur zur Überprüfung der Person genutzt und von Artyfact vertraulich und privat gehalten.',
        'ko': '이 정보는 신원 확인용으로만 사용되며 Artyfact에 의해 비공개 및 기밀로 유지됩니다.',
        'ch': '此信息仅用于个人验证，并由 Artyfact保密。',
        'ru': 'Эта информация используется только для проверки личности и хранится компанией Artyfact в тайне и конфиденциальности.',
        'it': 'Queste informazioni vengono utilizzate solo per la verifica personale e sono mantenute private e riservate da Artyfact.',
        'jap': 'この情報は本人確認のみに使用され、Artyfactにより社外秘かつ機密事項として保管されます。',
        'port': 'Essas informações são usadas apenas para verificação pessoal e são mantidas privadas e confidenciais pela Artyfact.',
        'turk': 'Bu bilgiler sadece kişisel doğrulama amacıyla kullanılır ve Artyfact tarafından gizli tutulur.',
        'viet': 'Thông tin này chỉ được sử dụng để xác minh thông tin cá nhân và được Artyfact giữ kín và bảo mật.',
        'spa': 'Esta información se utiliza únicamente para la verificación personal, y Artyfact la trata de forma privada y confidencial.',
        'arab': 'تُستخدم هذه المعلومات للتحقق الشخصي فقط، وتحافظ شركة أرتيفاكت على الخصوصية والسرية.'
    },
    step3_1: {
        'en': 'Identity Verification',
        'fr': 'Vérification d`identité',
        'de': 'Identitätsbestätigung',
        'ko': '신원 확인',
        'ch': '身份验证',
        'ru': 'Проверка личности',
        'it': 'Verifica dell`Identità',
        'jap': '本人確認',
        'port': 'Verificação de Identidade',
        'turk': 'Kimlik Doğrulama',
        'viet': 'Xác minh danh tính',
        'spa': 'Verificación de identidad',
        'arab': 'التحقق من الهوية'
    },
    step3_2: {
        'en': 'Use a valid government-issued document',
        'fr': 'Utilise un document officiel en cours de validité',
        'de': 'Verwenden Sie einen gültigen staatlichen Ausweis',
        'ko': '유효한 정부 발행 문서 사용',
        'ch': '使用政府签发的有效文件',
        'ru': 'Используйте действительный документ государственного образца',
        'it': 'Usare un documento valido rilasciato da un ente governativo',
        'jap': '政府発行の有効な書類をお使いください',
        'port': 'Use um documento válido emitido pelo governo',
        'turk': 'Geçerli, yetkili makamlarca düzenlenmiş bir belge kullanınız',
        'viet': 'Sử dụng tài liệu hợp lệ được chính phủ cấp phép',
        'spa': 'Utiliza un documento válido emitido por el gobierno',
        'arab': 'استخدم مستندًا حكوميًا صالحًا'
    },
    step3_3: {
        'en': 'ID Card',
        'fr': 'Carte d`identité',
        'de': 'Personalausweis',
        'ko': 'ID 카드',
        'ch': '身份证',
        'ru': 'Удостоверение личности',
        'it': 'Carta d`identità',
        'jap': 'IDカード',
        'port': 'Carteira de identidade',
        'turk': 'Kimlik Kartı',
        'viet': 'Thẻ ID',
        'spa': 'Documento de identidad',
        'arab': 'بطاقة التعريف'
    },
    step3_4: {
        'en': 'Passport',
        'fr': 'Passeport',
        'de': 'Pass',
        'ko': '여권',
        'ch': '护照',
        'ru': 'Паспорт',
        'it': 'Passaporto',
        'jap': 'パスポート',
        'port': 'Passaporte',
        'turk': 'Pasaport',
        'viet': 'Hộ chiếu',
        'spa': 'Pasaporte',
        'arab': 'جواز سفر'
    },
    step3_5: {
        'en': 'Driver`s License',
        'fr': 'Permis de conduire',
        'de': 'Fahrerlaubnis',
        'ko': '운전면허증',
        'ch': '驾驶执照',
        'ru': 'Водительское удостоверение',
        'it': 'Patente',
        'jap': '運転免許証',
        'port': 'Carteira de motorista',
        'turk': 'Sürücü Belgesi',
        'viet': 'Bằng lái xe',
        'spa': 'Permiso de conducir',
        'arab': 'رخصة السياقة'
    },
    step4_1: {
        'en': 'Upload image of',
        'fr': 'Téléchargement de la photo de',
        'de': 'Bild eines',
        'ko': 'ID 카드 이미지',
        'ch': '上传身份证图片',
        'ru': 'Загрузить изображение',
        'it': 'Carica foto della',
        'jap': 'IDカードの画像をアップロード',
        'port': 'Carregar imagem da',
        'turk': 'Kimlik fotoğrafı',
        'viet': 'Tải lên ảnh chụp',
        'spa': 'Cargar imagen de documento',
        'arab': 'تحميل صورة بطاقة الهوية'
    },
    step4_2: {
        'en': 'Full-size',
        'fr': 'Taille réelle',
        'de': 'In voller Größe',
        'ko': '최대 사이즈',
        'ch': '全尺寸',
        'ru': 'Полноразмерный',
        'it': 'Dimensione intera',
        'jap': 'フルサイズ',
        'port': 'Tamanho real',
        'turk': 'Tam ebat',
        'viet': 'Kích thước đầy đủ',
        'spa': 'Tamaño completo',
        'arab': 'بالحجم الكامل'
    },
    step4_3: {
        'en': 'Government-issued',
        'fr': 'Délivrée par l`administration',
        'de': 'Staatlich anerkannt',
        'ko': '정부 발행 문서여야 함',
        'ch': '政府签发',
        'ru': 'Государственного образца',
        'it': 'Rilasciato da un ente governativo',
        'jap': '政府発行',
        'port': 'Emitido pelo governo',
        'turk': 'Yetkili makamlarca düzenlenmiş',
        'viet': 'Được chính phủ cấp phép',
        'spa': 'Emitido por el gobierno',
        'arab': 'صادرة عن الحكومة'
    },
    step4_4: {
        'en': 'Not expired',
        'fr': 'En cours de validité',
        'de': 'Nicht abgelaufen',
        'ko': '만료되지 않은 문서여야 함',
        'ch': '未过期',
        'ru': 'Срок действия не истек',
        'it': 'In corso di validità',
        'jap': '期限切れではありません',
        'port': 'Válido',
        'turk': 'Tarihi geçmemiş',
        'viet': 'Chưa hết hạn',
        'spa': 'No ha caducado',
        'arab': 'ساري المفعول'
    },
    step4_5: {
        'en': 'No edits',
        'fr': 'Non modifiée',
        'de': 'Nicht bearbeitet',
        'ko': '수정되지 않은 문서여야 함',
        'ch': '未修改',
        'ru': 'Без правок',
        'it': 'Senza modifiche',
        'jap': '編集していません',
        'port': 'Sem edições',
        'turk': 'Düzenleme yapılmamış',
        'viet': 'Không chỉnh sửa',
        'spa': 'Sin ediciones',
        'arab': 'بلا تعديلات'
    },
    step4_6: {
        'en': 'File size must be between 10KB and 5120KB in jpg/jpeg/png format',
        'fr': 'La taille du fichier doit être comprise entre 10 Ko et 5120 Ko au format jpg/jpeg/png',
        'de': 'Die Datei muss eine Größe zwischen 10 KB und 5120 KB und ein Format von jpg/jpeg/png aufweisen',
        'ko': '파일 크기는 10KB에서 5120KB사이, 형식은 jpg/jpeg/png여야 합니다',
        'ch': '文件大小必须在10KB到5120KB之间，Jpg/jpeg/png格式',
        'ru': 'Размер файла должен быть от 10 КБ до 5120 КБ в формате jpg/jpeg/png.',
        'it': 'La dimensione del file deve essere compresa tra 10KB e 5120KB in formato jpg/jpeg/png',
        'jap': 'ファイルサイズは10KB以上5120KB以下、jpg/jpeg/png形式にしてください',
        'port': 'O tamanho do arquivo deve estar entre 10 KB e 5120 KB no formato jpg/jpeg/png',
        'turk': 'Dosya boyutu jpg/jpeg/png formatında 10KB ile 5120KB arası olmalıdır',
        'viet': 'Kích thước tệp phải từ 10KB và 5120KB trong định dạng jpg/jpeg/png',
        'spa': 'El tamaño del archivo debe estar entre 10 kB y 5120 kB en formato jpg/jpeg/png',
        'arab': 'يجب أن يكون حجم الملف بين 10KB و 5120KB صيغة jpg / jpeg / png'
    },
    file_front: {
        'en': 'Upload front page',
        'fr': 'Téléchargement du recto',
        'de': 'Vorderseite hochladen',
        'ko': '앞면 업로드',
        'ch': '上传正面',
        'ru': 'Загрузить переднюю сторону',
        'it': 'Carica fronte',
        'jap': '表面をアップロード',
        'port': 'Carregar página inicial',
        'turk': 'Ön sayfa yükle',
        'viet': 'Tải mặt trước',
        'spa': 'Cargar anverso',
        'arab': 'تحميل الصفحة الأولى'
    },
    file_back: {
        'en': 'Upload back page',
        'fr': 'Téléchargement du verso',
        'de': 'Rückseite hochladen',
        'ko': '뒷면 업로드',
        'ch': '上传背面',
        'ru': 'Загрузить заднюю сторону',
        'it': 'Carica retro',
        'jap': '裏面をアップロード',
        'port': 'Carregar página de volta',
        'turk': 'Arka sayfa yükle',
        'viet': 'Tải mặt sau',
        'spa': 'Cargar reverso',
        'arab': 'تحميل الصفحة الخلفية'
    },
    file_upload: {
        'en': 'File uploaded',
        'fr': 'Fichier téléchargé',
        'de': 'Hochgeladene Datei',
        'ko': '파일이 업로드 되었습니다',
        'ch': '文件已上传',
        'ru': 'Файл загружен',
        'it': 'File caricato',
        'jap': 'ファイルをアップロードしました',
        'port': 'Arquivo enviado',
        'turk': 'Dosya yüklendi',
        'viet': 'Tệp đã tải lên',
        'spa': 'Archivo cargado',
        'arab': 'تم الرفع ملف'
    },
    upload_pass: {
        'en': 'Upload image of Passport',
        'fr': 'Téléchargement de la photo du passeport',
        'de': 'Bild vom Pass hochladen',
        'ko': '여권 이미지 업로드',
        'ch': '上传护照图片',
        'ru': 'Загрузить изображние паспорта',
        'it': 'Carica foto del passaporto',
        'jap': 'パスポートの画像をアップロード',
        'port': 'Carregar imagem do passaporte',
        'turk': 'Pasaport görüntüsü yükle',
        'viet': 'Tải ảnh Hộ chiếu',
        'spa': 'Cargar imagen del pasaporte',
        'arab': 'تحميل صورة جواز السفر'
    },
    upload_driver: {
        'en': 'Upload image of Driver’s License',
        'fr': 'Téléchargement de la photo du permis de conduire',
        'de': 'Bild von der Fahrerlaubnis hochladen',
        'ko': '운전면허증 이미지 업로드',
        'ch': '上传驾驶执照图片',
        'ru': 'Загрузить изображение водительского удостоверения',
        'it': 'Carica foto della patente',
        'jap': '運転免許証の画像をアップロード',
        'port': 'Carregar imagem da carteira de motorista',
        'turk': 'Sürücü Belgesi görüntüsü yükle',
        'viet': 'Tải ảnh Bằng lái xe',
        'spa': 'Cargar imagen del permiso de conducir',
        'arab': 'تحميل صورة رخصة القيادة'
    },
    step5_1: {
        'en': 'Upload Selfie',
        'fr': 'Téléchargement du selfie',
        'de': 'Selfie hochladen',
        'ko': '본인 사진 업로드',
        'ch': '上传自拍',
        'ru': 'Загрузить селфи',
        'it': 'Carica Selfie',
        'jap': '自撮り写真をアップロード',
        'port': 'Selfie carregada',
        'turk': 'Özçekim Yükle',
        'viet': 'Tải lên ảnh selfie',
        'spa': 'Cargar selfie',
        'arab': 'تحميل صورة شخصية Selfie'
    },
    step5_2: {
        'en': 'Sufficient lighting',
        'fr': 'Lumière suffisante',
        'de': 'Ausreichende Beleuchtung',
        'ko': '충분한 조명',
        'ch': '充足的照明',
        'ru': 'Достаточное освещение',
        'it': 'Luce sufficiente',
        'jap': '十分な明るさがあります',
        'port': 'Iluminação suficiente',
        'turk': 'Yeterli ışık',
        'viet': 'Đủ ánh sáng',
        'spa': 'Suficiente iluminación',
        'arab': 'إضاءة كافية'
    },
    step5_3: {
        'en': 'No filters',
        'fr': 'Aucun filtre',
        'de': 'Keine Filter',
        'ko': '필터 금지',
        'ch': '无滤镜',
        'ru': 'Без фильтров',
        'it': 'Senza filtri',
        'jap': 'フィルターを使用していません',
        'port': 'Sem filtros',
        'turk': 'Filtresiz',
        'viet': 'Không có bộ lọc',
        'spa': 'Sin filtros',
        'arab': 'بلا المرشحات'
    },
    step5_4: {
        'en': 'Full face',
        'fr': 'Visage entier',
        'de': 'Ganzes Gesicht',
        'ko': '얼굴 전체가 보여야 함',
        'ch': '全脸',
        'ru': 'Лицо полностью',
        'it': 'Pieno volto',
        'jap': '顔全体が写っています',
        'port': 'Rosto inteiro',
        'turk': 'Yüzün tamamını gösteren',
        'viet': 'Đầy đủ khuôn mặt',
        'spa': 'Cara completa',
        'arab': 'وجه كامل'
    },
    step5_5: {
        'en': 'No glasses',
        'fr': 'Sans lunette',
        'de': 'Keine Brille',
        'ko': '안경 없는 사진',
        'ch': '无眼镜',
        'ru': 'Без очков',
        'it': 'Senza occhiali',
        'jap': '眼鏡をかけていません',
        'port': 'Sem óculos',
        'turk': 'Gözlüksüz',
        'viet': 'Không đeo kính',
        'spa': 'Sin gafas',
        'arab': 'بلا نظارات'
    },
    review: {
        'en': 'Under review',
        'fr': 'En cours de vérification',
        'de': 'In der Überprüfungsphase',
        'ko': '검토 중',
        'ch': '审核中',
        'ru': 'На рассмотрении',
        'it': 'In revisione',
        'jap': '調査中',
        'port': 'Sob revisão',
        'turk': 'İncelemede',
        'viet': 'Đang xem xét',
        'spa': 'En revisión',
        'arab': 'قيد المراجعة'
    },
    recive: {
        'en': 'You will receive an email once your verification is completed.',
        'fr': 'Vous recevrez un e-mail une fois la vérification terminée.',
        'de': 'Sie werden eine E-Mail erhalten, sobald Ihre Überprüfung abgeschlossen sein wird.',
        'ko': '확인이 완료될 시 이메일을 받게 됩니다.',
        'ch': '验证完成后，您将收到一封电子邮件。',
        'ru': 'Вы получите электронное письмо после завершения проверки.',
        'it': 'Riceverai una email una volta che la verifica è completa.',
        'jap': '確認が完了するとメールで通知が届きます。',
        'port': 'Você receberá um e-mail assim que sua verificação for concluída.',
        'turk': 'Doğrulama işleminiz tamamlandıktan sonra e-posta alırsınız.',
        'viet': 'Bạn sẽ nhận được một email sau khi xác minh hoàn tất.',
        'spa': 'Recibirás un correo electrónico una vez que se haya completado la verificación.',
        'arab': 'سوف تتلقى رسالة بريد إلكتروني بمجرد اكتمال التحقق الخاص بك.'
    },
    time: {
        'en': 'Estimated completion time:',
        'fr': 'Durée estimée de l`opération :',
        'de': 'Verbleibende Zeit bis zum Abschluss:',
        'ko': '예상 완료 시간',
        'ch': '预计完成时间：',
        'ru': 'Расчетное время завершения:',
        'it': 'Tempo stimato per il completamento:',
        'jap': '完了までの所要時間：',
        'port': 'Tempo estimado de conclusão:',
        'turk': 'Tahmini tamamlama süresi:',
        'viet': 'Thời gian hoàn tất ước tính:',
        'spa': 'Tiempo estimado de ejecución:',
        'arab': 'الوقت المقدر للانتهاء:'
    },
    day: {
        'en': '1 day',
        'fr': '1 jour',
        'de': '1 Tag',
        'ko': '1일',
        'ch': '1天',
        'ru': '1 день',
        'it': '1 giorno',
        'jap': '1日',
        'port': '1 dia',
        'turk': '1 gün',
        'viet': '1 ngày',
        'spa': '1 día',
        'arab': 'يوم واحدة'
    },
    file_big_image: {
        'en': 'File size to big',
        'fr': 'Le fichier est trop volumineux',
        'de': 'Die Datei ist zu groß',
        'ko': '파일이 너무 큽니다',
        'ch': '文件太大',
        'ru': 'Файл слишком большой',
        'it': 'Il file è troppo grande',
        'jap': 'ファイルが大きすぎます',
        'port': 'O arquivo é muito grande',
        'turk': 'Dosya çok büyük',
        'viet': 'Tệp quá lớn',
        'spa': 'El archivo es demasiado grande',
        'arab': 'الملف كبير جدًا'
    }
}